import Axios, { AxiosError } from 'axios';
import { APP_CONFIG } from '@/common';
import { PrecisePriceConfig } from '@/entities/config';
import {
	DealProgressStates, UpdateDealStateRequest,
} from '@/types/deal-progress';

const axios = Axios.create({
	baseURL: `${APP_CONFIG.API_URL}writeup/`,
});

export class DealProgressService {
	constructor({ apiKey, ppSSOKey }: PrecisePriceConfig) {
		axios.defaults.headers['X-Api-Key'] = apiKey;
		axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
		if (ppSSOKey !== undefined) {
			axios.defaults.headers['X-Pp-Key'] = ppSSOKey;
		}
	}

	public getStepsStates(writeupId: number): Promise<DealProgressStates> {
		return axios.get(`${writeupId}/state`)
			.then(res => res.data)
			.catch((error: AxiosError) => {
				if (error?.response?.status === 404) {
					return Promise.resolve(null);
				}
				throw error;
			});
	}

	public updateStepStatus(writeupId: number, data: UpdateDealStateRequest): Promise<DealProgressStates> {
		return axios.put(`${writeupId}/state`, data)
			.then(res => res.data)
			.catch((error: AxiosError) => {
				if (error?.response?.status === 404) {
					return Promise.resolve(null);
				}
				throw error;
			});
	}
}
